//
//
//
//
//
//
//
//

import JSZip from 'jszip';

export default {
  props: {
    id: { type: String, default: 'editor' },
    texto: { type: String, default: '' },
  },
  data() {
    return {
      editor: undefined,
    };
  },
  methods: {
    criar() {
      this.editor = $(`#${this.id}`).kendoEditor();
    },
    startKendoUI() {
      window.kendo.culture('pt-BR');
      this.criar();
    },
    getTexto() {
      return this.editor.data('kendoEditor').value();
    },
    setTexto(valor) {
      if (this.editor) {
        this.editor.data('kendoEditor').value(valor);
      }
    },
  },
  mounted() {
    window.JSZip = JSZip;
    if (window.kendo) {
      this.startKendoUI();
      return;
    }

    $.getScript('static/js/kendoui/kendoui.js', () => {
      this.startKendoUI();
    });
  },
};



// WEBPACK FOOTER //
// ./src/shared-components/editor/Editor.vue?vue&type=script&lang=js&